module.exports = __webpack_public_path__ + "img/drzwi.ad4e7899.jpg";